// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1deeJ","col":"styles_col__3GrJe","fulfillmentStatus":"styles_fulfillmentStatus__2C40V","emailCol":"styles_emailCol__2USsO"};